import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import {
  faDollarSign,
  faTh,
  faHome,
  faUsersCog,
  faSms,
  faTrash,
  faFileUpload,
} from '@fortawesome/free-solid-svg-icons';
import { register } from 'swiper/element/bundle';

import { currentYearString } from '../../../../../shared/utilities/times/times';
import { ConnectedUserModel } from '../../interfaces/users-models';
import { UsersService } from '../../services/users.service';

// Register Swiper elements

// Register Swiper custom elements
register();

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class AppLayoutComponent implements OnInit {
  // Icons
  faHome = faHome;
  faDollarSign = faDollarSign;
  faTh = faTh;
  faUsersCog = faUsersCog;
  faSms = faSms;
  faTrash = faTrash;
  faFileUpload = faFileUpload;

  currentYear = currentYearString;

  // Swiper configuration is now handled by swiper-container attributes

  showSidebar = false;

  connectedUser: ConnectedUserModel | null;
  usersService: UsersService;
  router: Router;
  cdr: ChangeDetectorRef;

  constructor() {
    this.usersService = inject(UsersService);
    this.router = inject(Router);
    this.cdr = inject(ChangeDetectorRef);
    this.connectedUser = this.usersService.getConnectedUserSync();

    this.usersService.connectedUserChanged.subscribe((connectedUser) => {
      this.connectedUser = connectedUser;
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showSidebar = false;
        this.cdr.detectChanges();
      }
    });
  }

  // Sidebar toggle
  public toggleSidebar(): void {
    this.showSidebar = !this.showSidebar;
  }

  public logout(): void {
    this.usersService
      .signOut()
      .then(() => {
        return this.router.navigate(['/login']);
      })
      .catch((error) => {
        console.error('Error logging out', error);
        return false;
      });
  }
}
